<template>
    <v-layout v-if="!cookieVal" class="gdpr" >
      <v-flex>
        This site uses cookies to help improve your user experience.
        By continuing to use our site you are consenting to our
          <router-link :to="{'name':'Policies'}">policies</router-link>,
      </v-flex>
      <div class="text-xs-right" style="vertical-align:super;">
        <v-icon color="yellow" @click="acceptCookies">{{ mdiClose }}</v-icon>
      </div>
  </v-layout>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  name: 'GDPR',
  data: function () {
    return {
      mdiClose: mdiClose,
      cookieVal: false
    }
  },
  mounted: function () {
    this.cookieVal = this.$cookies.get('attsacceptgdpr')
  },
  methods: {
    acceptCookies: function () {
      const t = (new Date()).getTime()
      this.$cookies.set('attsacceptgdpr', t, '5y')
      this.cookieVal = t
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.gdpr {
   position:fixed;
   bottom:0;
   left:0;
   width:100%;
   background:#CBCACA;
   color: #F9F6F9;
   padding:5px;
   z-index:1000;
}

a {
  color: yellow;
}

</style>
